import { useState, useRef } from 'react';
import axios from 'axios';
import ReactGA from 'react-ga4';
import { getBaseUrl } from '../utils/request';

const useAudioRecording = ( handleSetMessage, setInput) => {
    const [isRecording, setIsRecording] = useState(false);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            mediaRecorderRef.current = new MediaRecorder(stream, { mimeType: 'audio/webm' });

            mediaRecorderRef.current.ondataavailable = (event) => {
                audioChunksRef.current.push(event.data);
            };

            mediaRecorderRef.current.onstop = () => {
                const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
                audioChunksRef.current = [];
                handleAudioSubmit(audioBlob);
            };

            mediaRecorderRef.current.start();
            setIsRecording(true);
        } catch (error) {
            console.error("Error accessing microphone:", error);
        }
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current && isRecording) {
            mediaRecorderRef.current.stop();
            setIsRecording(false);
        }
    };

    const handleAudioSubmit = async (audioBlob) => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Sent audio'
        });

        const formData = new FormData();
        formData.append('audio', audioBlob, 'recording.m4a');

        try {
            const response = await axios.post(`${getBaseUrl()}/vedai/transcribe-audio`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const transcribedText = JSON.parse(response.data.data).text;
            setInput(transcribedText.trim());
        } catch (error) {
            console.error("Error in speech-to-text conversion:", error);
            handleSetMessage("Failed to process audio. Please try again.", "system");
        }
    };

    const toggleRecording = () => {
        if (isRecording) {
            stopRecording();
        } else {
            startRecording();
        }
    };

    return { isRecording, toggleRecording };
};

export default useAudioRecording;
